import { render } from "./FooterSearchMenu.vue?vue&type=template&id=7a0fa783&scoped=true"
import script from "./FooterSearchMenu.vue?vue&type=script&lang=js"
export * from "./FooterSearchMenu.vue?vue&type=script&lang=js"

import "./FooterSearchMenu.vue?vue&type=style&index=0&id=7a0fa783&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0fa783"]])

export default __exports__